import React from "react";
import logo from "../../assets/logo/logo.svg";
import { LogoutIcon, SearchIcon } from "../../assets/icons/icons";
import { Link } from "react-router-dom";
import Searchbar from "../common/searchbar";
import { useAuth } from "../../context/AuthContext";

export default function Header() {
  const { logout } = useAuth();
  return (
    <header className="container mx-auto grid grid-cols-3 items-center py-5">
      <Link to="/" className="flex w-fit flex-row items-center gap-[16px]">
        <img src={logo} alt="logo" />
        <h1 className="text-left font-outfit text-[20px] font-semibold leading-[25.2px] text-[#222222]">
          Funsol APIs
        </h1>
      </Link>

      <div className="relative">
        {/* <Searchbar placeholder="Search Api here " /> */}
      </div>

      <div className="flex items-center justify-end" onClick={() => logout()}>
        <LogoutIcon />
      </div>
    </header>
  );
}
